import type useMapRadius from 'app/hooks/use-map-radius';
import {
  IconBriefcase,
  IconBuilding,
  IconHeart,
  IconHome,
  IconMapPin,
  IconUser,
  IconUsersGroup,
} from '@tabler/icons-react-native';
import { type useScopedTranslation } from 'app/hooks/i18n';
import { createTheme as createDSTheme } from 'app/shopify';
import { useState } from 'react';

export const theme = createDSTheme();

export type SelectedAddress = ReturnType<typeof useMapRadius>['selectedAddress'];

export const buildHeaderTitle = (
  t: ReturnType<typeof useScopedTranslation>['t'],
  hasAddressId: boolean,
  selectedAddress: SelectedAddress,
) =>
  t(
    !hasAddressId
      ? 'titleNew'
      : t('clubName', {
          clubName: !selectedAddress ? '...' : (selectedAddress.name ?? t('neighbourhoodClubName', { ns: 'my-clubs' })),
        }),
    { postalCode: selectedAddress?.postalCode },
  );

export const ADDRESS_ICONS = [
  { id: 1, Icon: IconHome },
  { id: 2, Icon: IconBriefcase },
  { id: 3, Icon: IconBuilding },
  { id: 4, Icon: IconHeart },
  { id: 5, Icon: IconMapPin },
  { id: 6, Icon: IconUsersGroup },
  { id: 7, Icon: IconUser },
];

export const useSelectedAddressIcon = (selectedAddress: SelectedAddress) => {
  const selectedAddressId = selectedAddress?.id;
  const [selectedIcon, setSelectedIcon] = useState<number>(selectedAddress?.icon ?? 0);
  const [selectedIconAddressId, setSelectedIconAddressId] = useState(selectedAddressId);

  if (selectedAddressId !== selectedIconAddressId) {
    setSelectedIconAddressId(selectedAddressId);
    setSelectedIcon(selectedAddress?.icon ?? 0);
  }

  return { selectedAddressId, selectedIcon, setSelectedIcon };
};
